export const DEFAULT_TENANT_BRANDING = {
  primaryColor: "#0b2230",
  accentColor: "#20a895",
} as const;

export type TenantBranding = {
  organisationName: string;
  logoPath: string | null;
  logoUrl: string | null;
  primaryColor: string;
  accentColor: string;
};

type BrandingSettings = {
  logo_path?: unknown;
  primary_color?: unknown;
  accent_color?: unknown;
};

const HEX_COLOUR = /^#[0-9a-f]{6}$/i;

export function safeBrandColour(value: unknown, fallback: string) {
  return typeof value === "string" && HEX_COLOUR.test(value) ? value.toLowerCase() : fallback;
}

export function brandingFromSettings(organisationName: string, settings: Record<string, unknown>): TenantBranding {
  const branding = settings.branding && typeof settings.branding === "object" ? settings.branding as BrandingSettings : {};
  return {
    organisationName,
    logoPath: typeof branding.logo_path === "string" && branding.logo_path ? branding.logo_path : null,
    logoUrl: null,
    primaryColor: safeBrandColour(branding.primary_color, DEFAULT_TENANT_BRANDING.primaryColor),
    accentColor: safeBrandColour(branding.accent_color, DEFAULT_TENANT_BRANDING.accentColor),
  };
}

export function contrastColour(hex: string) {
  const value = safeBrandColour(hex, DEFAULT_TENANT_BRANDING.primaryColor).slice(1);
  const red = Number.parseInt(value.slice(0, 2), 16);
  const green = Number.parseInt(value.slice(2, 4), 16);
  const blue = Number.parseInt(value.slice(4, 6), 16);
  return (red * 299 + green * 587 + blue * 114) / 1000 >= 150 ? "#102733" : "#ffffff";
}
